import { useContext, useEffect } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import * as H from 'history'
import { Sample, SampleSearchForm } from 'entities/sample'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { A4 } from 'components/shared/print'
import Arrow from 'api/../../public/arrow.png'
import LungResult from 'api/../../public/lung.jpg'
import LungMainResult from 'api/../../public/lung_main.jpg'
import LungQcResult from 'api/../../public/lung_qc.jpg'
import LungRiskMarkerResult from 'api/../../public/lung_risk.jpg'
import OvaryResult from 'api/../../public/ovary.jpg'
import OvaryMainResult from 'api/../../public/ovary_main.jpg'
import OvaryQcResult from 'api/../../public/ovary_qc.jpg'
import OvaryRiskMarkerResult from 'api/../../public/ovary_risk.jpg'
import OvaryNetwork from 'api/../../public/ovary_network.png'
import OvaryIncBar from 'api/../../public/ovary_inc_bar.png'
import OvaryDescBar from 'api/../../public/ovary_desc_bar.png'
import OvaryDist from 'api/../../public/ovary_dist.png'
import NgLungResult from 'api/../../public/lung_ng.jpg'
import NgOvaryResult from 'api/../../public/ovary_ng.jpg'
import '../send_history/preview.scss'
import { PatientViewModel } from 'view_models/patient_view_model'
import { SampleViewModel } from 'view_models/sample_view_model'
import { usePatchSendHistoryApi } from 'api/send_history'
import { SendHistoryForm } from 'entities/send_history'
import { Result } from 'entities/result'
import { ResultViewModel } from 'view_models/result_view_model'
import { ProductItem } from 'entities/product_item'
import { setPageSize } from 'utils/util'
import { PcrTestSample } from 'entities/pcr_test_sample'
import { PcrTestResult } from 'entities/pcr_test_result'
import { useFetchPcrTestRunApi } from 'api/pcr_test_run'

const ngResultImages: { [key: string]: string } = {
    lung: NgLungResult,
    ovary: NgOvaryResult,
}

const resultImages: { [key: string]: string } = {
    lung: LungResult,
    lungMain: LungMainResult,
    lungRiskMarker: LungRiskMarkerResult,
    lungQc: LungQcResult,
    ovary: OvaryResult,
    ovaryMain: OvaryMainResult,
    ovaryRiskMarker: OvaryRiskMarkerResult,
    ovaryQc: OvaryQcResult,
    ovaryNetwork: OvaryNetwork,
    ovaryIncBar: OvaryIncBar,
    ovaryDescBar: OvaryDescBar,
    ovaryDist: OvaryDist,
    arrow: Arrow,
}

type Props = {
    history: H.History
}

const PreviewResultsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useParams<{ id: string }>()
    const query = useQuery<SampleSearchForm>()
    const api = useFetchPcrTestRunApi()
    const updateForm = useForm<SendHistoryForm>({ status: 'RESULT_PRINTED' })
    const updateApi = usePatchSendHistoryApi()

    useEffect(() => {
        api.execute(Number(params.id))
        setPageSize('portrait')
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    return (
        <>
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="flex-end">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            {api.response.pcrTestRun?.pcrTestSamples?.map((sample, i) => (
                <>
                    {/* <ResultGuidancePaper sample={sample} /> */}
                    <>
                        {sample.pcrTestResult && <OkResultPaper key={`page-${i}`} sample={sample} result={sample.pcrTestResult} />}
                        {/* <RiskMarkerResultPaper key={`page-${i}-${j}`} sample={sample} result={result} /> */}
                        {/* <QcResultPaper key={`page-${i}-${j}`} sample={sample} result={result} /> */}
                    </>
                </>
            ))}
        </>
    )
}

export default withRouter(PreviewResultsPage)

type NgResultPaperProps = {
    key?: string
    sample: Sample
    productItem: ProductItem
}

const NgResultPaper = (props: NgResultPaperProps) => {
    const { key, sample, productItem } = props
    const vm = new SampleViewModel(sample)
    const patientVm = new PatientViewModel(sample.patient!)
    return (
        <A4 key={key ?? 'key'} padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={ngResultImages[`${productItem.nameEn!}`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 10, top: 10, fontSize: 10 }}>{patientVm.object.code}</div>
                <div style={{ position: 'absolute', right: 150, top: 50, fontSize: 24 }}>{patientVm.fullName()}</div>
                <div className="patient-info" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                    <div style={{ position: 'absolute', left: 525, top: 103 }}>{patientVm.age()}</div>
                    <div style={{ position: 'absolute', left: 606, top: 103 }}>{patientVm.gender()}</div>
                    <div style={{ position: 'absolute', left: 555, top: 131 }}>{sample.karteNumber}</div>
                    <div style={{ position: 'absolute', left: 678, top: 131 }}>{vm.collectionDateText()}</div>
                    <div style={{ position: 'absolute', left: 560, top: 158 }}>{sample.institution?.name}</div>
                    <div style={{ position: 'absolute', left: 560, top: 187 }}>{sample.institution?.code}</div>
                </div>
                <div style={{ position: 'absolute', left: 90, top: 330, fontSize: 70, fontWeight: 'bold' }}>{'ー'}</div>
                <div style={{ position: 'absolute', left: 220, top: 330, fontWeight: 'bold' }}>
                    <div>今回は以下の理由で検査ができませんでした。</div>
                    {sample.differentContainer && <div>・指定容器以外の容器でのご提出のため</div>}
                    {sample.nonUrine && <div>・尿以外の検体のご提出のため</div>}
                    {sample.quantityStatus === 'NG' && <div>・尿量が1ml以下であったため</div>}
                </div>
                <div style={{ position: 'absolute', top: 580, left: 80, width: 172 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{'N/A'}</div>
                </div>
                <div style={{ position: 'absolute', top: 580, left: 315, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{'N/A'}</div>
                </div>
                <div style={{ position: 'absolute', top: 580, left: 550, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{'N/A'}</div>
                </div>
            </div>
        </A4>
    )
}

type OkResultPaperProps = {
    sample: PcrTestSample
    result: PcrTestResult
}

const OkResultPaper = (props: OkResultPaperProps) => {
    const { sample, result } = props
    const vm = new SampleViewModel(sample)
    const resultVm = new ResultViewModel(result)
    const referenceReasons = vm.getReferenceReason()

    const getRiskLevelPos = (productItem: ProductItem): number | undefined => {
        if (productItem.nameEn === 'lung') {
            return 244
        } else if (productItem.nameEn === 'ovary') {
            return 225
        } else {
            return undefined
        }
    }

    return (
        <A4 padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={resultImages[`${result.productItem!.nameEn!}Main`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 10, top: 10, fontSize: 10 }}>{sample.code}</div>
                <div style={{ position: 'absolute', right: 100, top: 45, fontSize: 24, width: 500, textAlign: 'right' }}>{sample.code}</div>
                <div
                    style={{
                        position: 'absolute',
                        left: 10,
                        top: 10,
                        fontSize: 24,
                        padding: '5px 10px',
                        border: 'solid 3px red',
                        borderRadius: 10,
                        color: 'red',
                    }}
                >
                    TEST用
                </div>
                <div className="patient-info" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                    <div style={{ position: 'absolute', left: 525, top: 103 }}>{sample.age}</div>
                    <div style={{ position: 'absolute', left: 606, top: 103 }}>{sample.gender}</div>
                </div>
                <div style={{ position: 'absolute', left: 100, top: 320, fontSize: 70, fontWeight: 'bold' }}>{resultVm.riskLevel()}</div>
                <div
                    style={{
                        position: 'absolute',
                        right: getRiskLevelPos(result.productItem!),
                        top: 329,
                        fontSize: 15,
                        fontWeight: 'bold',
                    }}
                >
                    {resultVm.riskLevel()}
                </div>

                <div style={{ position: 'absolute', top: 555, left: 80, width: 172 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{resultVm.riskRatio()}</div>
                    <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        あなたと同じ性別・年代における{result.productItem?.name}
                        へのかかりやすさと、今回の解析結果から、実際にがんと診断される確率を予測した値です。
                    </div>
                </div>
                <div style={{ position: 'absolute', top: 555, left: 315, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{resultVm.riskComparison()}</div>
                    <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        あなたと同じ性別・年代で{result.productItem?.name}にかかっている割合は1万人に
                        {resultVm.numberOfPeople()}
                        です。
                    </div>
                </div>
                <div style={{ position: 'absolute', top: 555, left: 550, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{resultVm.riskLevel()}</div>
                    <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        今回の検査の結果、現時点のがんリスクは「<span>{resultVm.riskLevel()}</span>
                        」と判定されています。
                        {resultVm.riskLevel() === '低' ? (
                            <>今後も定期的に検診を受けましょう</>
                        ) : (
                            <>念のため、医師と相談の上、{resultVm.part()}の状態を病院でチェックしましょう</>
                        )}
                    </div>
                </div>
                <div style={{ width: 640, backgroundColor: '#8888', position: 'absolute', top: 786, left: 73 }}>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        {(() => {
                            const i = resultVm.info()
                            if (i && i.score) {
                                const ratio = resultVm.barPointRatio()
                                const value = resultVm.convertViewScore()
                                return (
                                    <div style={{ position: 'absolute', left: 625 * ratio }}>
                                        <div style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 2 }}>{Math.round(value * 10) / 10}</div>
                                        <div className="triangle" style={{ height: 10, width: 10 }}></div>
                                    </div>
                                )
                            }
                        })()}
                    </div>
                </div>
            </div>
        </A4>
    )
}

type RiskMarkerResultPaperProps = {
    sample: PcrTestSample
    result: PcrTestResult
}

const RiskMarkerResultPaper = (props: RiskMarkerResultPaperProps) => {
    const { sample, result } = props
    const resultVm = new ResultViewModel(result)
    return (
        <A4 padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={resultImages[`${result.productItem!.nameEn!}RiskMarker`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 100, top: 53, fontSize: 12 }}>{sample.code}</div>
                {/* 冒頭の説明文 */}
                <div style={{ position: 'absolute', left: 55, top: 160, width: 690, fontSize: 11 }}>
                    {result.productItem?.name}
                    に特有のmiRNAの発現量を定量し、発現パターンについての評価を行いました。全てのmiRNAスコアを総合して、人工知能(AI)によるアル
                    ゴリズムに基づき、がんリスクスコアの算出を行いました。
                </div>
                {/* スコア欄を大きく囲う色付きの四角の線 */}
                <div
                    style={{
                        position: 'absolute',
                        border: '1px solid',
                        borderColor: result.productItem?.color,
                        left: 255,
                        top: 220,
                        width: 450,
                        height: 45 + 70 * resultVm.riskMarkers().length,
                    }}
                />
                {/* AIっぽいネットワークの画像 */}
                <img
                    src={resultImages[`${result.productItem!.nameEn!}Network`]}
                    style={{ position: 'absolute', left: 430, top: 262 + 70 * resultVm.riskMarkers().length, width: 50, backgroundColor: 'white' }}
                />
                {/* 下のリスクスコアの赤い四角 */}
                <Flex
                    alignItems="center"
                    style={{
                        paddingLeft: 20,
                        position: 'absolute',
                        backgroundColor: result.productItem?.color,
                        left: 305,
                        top: 332 + 70 * resultVm.riskMarkers().length,
                        width: 300,
                        height: 50,
                        color: 'white',
                    }}
                >
                    <div>あなたのがんリスクスコア</div>
                    <Flex style={{ backgroundColor: '#fff', width: 50, height: 20, textAlign: 'center' }} alignItems="center">
                        <div style={{ width: '100%', height: '100%', alignItems: 'center', color: 'black', fontSize: 13 }}>3.2</div>
                    </Flex>
                </Flex>

                {/* 一番上の黒線  */}
                <div
                    style={{
                        position: 'absolute',
                        borderBottom: '1px solid',
                        borderBottomColor: '#000',
                        left: 75,
                        top: 220,
                        width: 600,
                        height: 30,
                        fontSize: 20,
                        fontWeight: 'bold',
                    }}
                >
                    測定結果
                </div>
                {/* マーカー列の薄い色付き背景の四角 */}
                <div
                    style={{
                        backgroundColor: result.productItem?.color + '25',
                        position: 'absolute',
                        left: 280,
                        top: 225,
                        width: 100,
                        height: 32 + 70 * resultVm.riskMarkers().length,
                        fontSize: 12,
                        textAlign: 'center',
                        paddingTop: 5,
                    }}
                >
                    スコア
                </div>
                {resultVm.riskMarkers().map((item: Record<string, any>, i: number) => {
                    return (
                        <>
                            {/* 黒線と、miRNAの名前  */}
                            <Flex
                                key={i}
                                style={{
                                    position: 'absolute',
                                    borderBottom: '1px solid',
                                    borderBottomColor: '#000',
                                    left: 75,
                                    top: 250 + 70 * i,
                                    width: 600,
                                    height: 70,
                                    fontSize: 11,
                                }}
                            >
                                <Flex
                                    style={{
                                        alignItems: 'center',
                                        fontWeight: 'bold',
                                        height: '100%',
                                        width: 180,
                                        fontSize: 13,
                                        marginLeft: 10,
                                        marginBottom: 0,
                                    }}
                                >
                                    Cancer-risk miRNA #{i + 1}
                                </Flex>
                                <img src={resultImages[`${result.productItem!.nameEn!}IncBar`]} style={{ width: 420, marginTop: 20, paddingLeft: 150 }} />
                            </Flex>
                            {/* 白い四角(スコア) */}
                            <Flex
                                key={i}
                                style={{
                                    position: 'absolute',
                                    backgroundColor: '#fff',
                                    left: 305,
                                    top: 275 + 70 * i,
                                    width: 50,
                                    height: 20,
                                    fontSize: 13,
                                    textAlign: 'center',
                                }}
                                alignItems="center"
                            >
                                <div style={{ width: '100%', height: '100%', alignItems: 'center' }}>
                                    {(((item.ct - item.min) / (item.max - item.min)) * 10).toFixed(1)}
                                </div>
                            </Flex>
                            <div style={{ width: 640, backgroundColor: '#8888', position: 'absolute', top: 250 + 70 * i, left: 400 }}>
                                <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                                    {(() => {
                                        const i = resultVm.info()
                                        if (i && i.score) {
                                            const ratio = resultVm.barPointRatio()
                                            const value = resultVm.convertViewScore()
                                            return (
                                                <div style={{ position: 'absolute', left: 100 * ratio }}>
                                                    <div style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 2 }}>{Math.round(value * 10) / 10}</div>
                                                    <div className="triangle" style={{ height: 10, width: 10 }}></div>
                                                </div>
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                        </>
                    )
                })}
            </div>
        </A4>
    )
}

type QcResultPaperProps = {
    key: string
    sample: Sample
    result: Result
}

const QcResultPaper = (props: QcResultPaperProps) => {
    const { key, sample, result } = props
    const vm = new SampleViewModel(sample)
    const patientVm = new PatientViewModel(sample.patient!)
    const resultVm = new ResultViewModel(result)
    const referenceReasons = vm.getReferenceReason()

    const QcResultRow = (marker: Record<string, any>, mirnaName: string, whatNumber: number) => {
        return (
            <>
                {/* 黒線と、miRNAの名前  */}
                <Flex
                    key={mirnaName}
                    style={{
                        position: 'absolute',
                        borderBottom: '1px solid',
                        borderBottomColor: 'black',
                        left: 75,
                        top: 350 + 100 * whatNumber,
                        width: 600,
                        height: 100,
                        fontSize: 11,
                    }}
                >
                    <Flex style={{ alignItems: 'center', fontWeight: 'bold', height: '100%', width: 180, fontSize: 13, marginLeft: 10, marginBottom: 0 }}>
                        {mirnaName}
                    </Flex>
                    <img src={resultImages[`${result.productItem!.nameEn!}Dist`]} style={{ width: 420, marginTop: 20, paddingLeft: 200 }} />
                </Flex>

                <Flex
                    key={mirnaName}
                    style={{ position: 'absolute', left: 250, top: 375 + 100 * whatNumber, width: 200, height: 20, fontSize: 13, textAlign: 'center' }}
                    alignItems="center"
                    flexDirection="column"
                >
                    {/* 白い四角(スコア) */}
                    <div style={{ width: 50, height: '100%', alignItems: 'center', backgroundColor: 'white' }}>
                        {(((marker.ct - marker.min) / (marker.max - marker.min)) * 10).toFixed(1)}
                    </div>
                    <Flex style={{ textAlign: 'center', width: '100%', justifyContent: 'center' }} className="">
                        <div>{'(基準値 '}</div>
                        {/* 白い四角(スコア) */}
                        <div style={{ width: 50, alignItems: 'center', backgroundColor: 'white', height: 20, marginLeft: 3 }}>
                            {(((marker.ct - marker.min) / (marker.max - marker.min)) * 10).toFixed(1)}
                        </div>
                        <div style={{ marginLeft: 3 }}>~ </div>
                        <div style={{ width: 50, alignItems: 'center', backgroundColor: 'white', height: 20, marginLeft: 3 }}>
                            {(((marker.ct - marker.min) / (marker.max - marker.min)) * 10).toFixed(1)}
                        </div>
                        <div style={{ marginLeft: 3 }}>)</div>
                    </Flex>
                </Flex>
                <div style={{ width: 640, position: 'absolute', top: 392 + 100 * whatNumber, left: 500 }}>
                    <img src={resultImages[`arrow`]} style={{ width: 8 }} />
                </div>
            </>
        )
    }

    return (
        <A4 key={key ?? 'key'} padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={resultImages[`${result.productItem!.nameEn!}Qc`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 100, top: 53, fontSize: 12 }}>{patientVm.fullName()}</div>
                <div style={{ position: 'absolute', right: 75, top: 80, fontSize: 12 }}>{sample.karteNumber}</div>

                {/* 一番上の黒線  */}
                <div
                    style={{
                        position: 'absolute',
                        borderBottom: '1px solid',
                        borderBottomColor: '#000',
                        left: 75,
                        top: 320,
                        width: 600,
                        height: 30,
                        fontSize: 20,
                        fontWeight: 'bold',
                    }}
                >
                    測定結果
                </div>
                {/* マーカー列の薄い色付き背景の四角 */}
                <div
                    style={{
                        backgroundColor: result.productItem?.color + '25',
                        position: 'absolute',
                        left: 250,
                        top: 325,
                        width: 200,
                        height: 32 + 100 * (resultVm.allMarkers().length - resultVm.riskMarkers().length),
                        fontSize: 12,
                        textAlign: 'center',
                        paddingTop: 5,
                    }}
                >
                    測定値
                </div>
                {resultVm.hkMarkers().map((item: Record<string, any>, i: number) => {
                    return QcResultRow(item, `HK miRNA #${i + 1}`, i)
                })}
                {resultVm.RtSpikeInMarkers().map((item: Record<string, any>, i: number) => {
                    return QcResultRow(item, `HK miRNA #${i + 1}`, i + resultVm.hkMarkers().length)
                })}
                {resultVm.RnaSpikeInMarkers().map((item: Record<string, any>, i: number) => {
                    return QcResultRow(item, `RNA spike-in miRNA #${i + 1}`, i + resultVm.hkMarkers().length + resultVm.RtSpikeInMarkers().length)
                })}
            </div>
        </A4>
    )
}
